/**
 * Estilo común de las tablas de Presentaciones (RGRL/RRL, RAR y la grilla SVCC
 * por CUIT): tarjeta con borde suave y esquinas redondeadas en vez de la
 * sombra del Paper, header más bajo y en mayúsculas chicas, una línea entre
 * filas y la paginación dentro del borde.
 *
 * El color del header NO se toca: lo pone el theme (`MuiTableCell.head` =
 * `primary.light`, el color de marca de la organización), igual que en el
 * resto de la app.
 *
 * Va en el `sx` de un contenedor que envuelve a `DataTable`; el componente
 * global no cambia para el resto de la app.
 */
export const ESTILO_TABLA_PRESENTACIONES = {
    borderRadius: '12px',
    border: '1px solid #E0EBED',
    overflow: 'hidden',
    bgcolor: '#FFFFFF',
    '& .MuiPaper-root': { borderRadius: 0, boxShadow: 'none' },
    // DataTable corta en 746 px con scroll interno: la tabla crece y pagina.
    '& .MuiTableContainer-root': { maxHeight: 'none' },
    '& table thead th': {
        fontSize: '12px !important',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        whiteSpace: 'nowrap',
        paddingTop: '12px !important',
        paddingBottom: '12px !important'
    },
    '& table tbody tr': { outline: 'none' },
    '& table tbody td': { borderBottom: '1px solid #E0EBED' },
    // Los botones de acción de la fila (PDF, ver, menú) con el mismo radio que el resto.
    '& table tbody td button': { borderRadius: '8px' }
} as const;
